import { searchableSelectSectionSimpleTree } from "#/frontend-utils/constants/data-test-ids/components/searchable-select-section-simple-tree";
import { sectionApplianceText } from "#/frontend-utils/constants/data-test-ids/components/section-appliance-text-data-test-ids";
import { sectionPath } from "#/frontend-utils/constants/data-test-ids/components/section-path";
import { selectSectionSimpleTree } from "#/frontend-utils/constants/data-test-ids/components/select-section-simple-tree";
import { siteSectionApplianceCard } from "#/frontend-utils/constants/data-test-ids/components/site-section-appliance-card";
import { siteSectionAppliancesCountByProgrammingCategory } from "#/frontend-utils/constants/data-test-ids/components/site-section-appliances-count-by-programming-category";
import { siteSectionAppliancesSummary } from "#/frontend-utils/constants/data-test-ids/components/site-section-appliances-summary";
import { siteTreeStructure } from "#/frontend-utils/constants/data-test-ids/components/site-tree-structure";

interface DataTestIds {
  components: Record<string, { component: string }>;
}

export const DATA_TEST_IDS = {
  components: {
    searchableSelectSectionSimpleTree,
    sectionApplianceText,
    sectionPath,
    selectSectionSimpleTree,
    siteSectionApplianceCard,
    siteSectionAppliancesCountByProgrammingCategory,
    siteSectionAppliancesSummary,
    siteTreeStructure,
  },
} as const satisfies DataTestIds;
